import { motion } from "framer-motion";
import styles from "./StateCards.module.css";
import { useState } from "react";

const DEFAULT_Y = 10;
const STATES_PER_ROW = 3;

const yOffsetAtRest = (i: number, numStates: number) => {
  if (numStates === 1 || numStates === 2) {
    return 0;
  }

  if (i === 0) {
    return 4;
  } else if (i === 1) {
    return -4;
  }
  return 4;
};

const rotateAtRest = (i: number, numStates: number) => {
  if (numStates === 1) {
    return 0;
  }

  if (numStates === 2) {
    if (i === 0) {
      return -10;
    }
    return 10;
  }

  if (i === 0) {
    return -10;
  } else if (i === 1) {
    return 0;
  }
  return 10;
};

const xOffsetAtHover = (i: number) => {
  return (i % STATES_PER_ROW) * 30;
};

const yOffsetAtHover = (i: number, numStates: number) => {
  const numRows = Math.floor((numStates - 1) / STATES_PER_ROW);
  const rowHeight = 22;
  const currentRow = Math.floor(i / STATES_PER_ROW);
  const midRow = numRows / 2;

  return DEFAULT_Y + (currentRow - midRow) * rowHeight;
};

export const StateCards = ({
  states,
  reportId,
}: {
  states: string[];
  reportId: string;
}) => {
  const [isHovered, setIsHovered] = useState(false);
  const visibleStates: { [key: string]: string } = {};

  if (states.length > 3 && !isHovered) {
    for (const state of states.slice(0, 3)) {
      if (state === states[2]) {
        visibleStates[state] = `+${states.length - 2}`;
      } else {
        visibleStates[state] = state;
      }
    }
  } else {
    for (const state of states) {
      visibleStates[state] = state;
    }
  }

  return (
    <motion.div
      initial="rest"
      whileHover="hover"
      transition={{ duration: 0.2 }}
      className={styles.container}
      onHoverStart={() => setIsHovered(true)}
      onHoverEnd={() => setIsHovered(false)}
    >
      {states.map((state, i) => {
        const isVisible = state in visibleStates;
        return (
          <motion.div
            className={styles.stateCard}
            style={{ display: isVisible ? "flex" : "none" }}
            key={reportId + "_" + state}
            variants={{
              rest: {
                x: i * 20,
                rotate: rotateAtRest(i, Object.keys(visibleStates).length),
                y:
                  DEFAULT_Y +
                  yOffsetAtRest(i, Object.keys(visibleStates).length),
                opacity: isVisible ? 1 : 0,
              },
              hover: {
                x: xOffsetAtHover(i),
                y: yOffsetAtHover(i, states.length),
                rotate: 0,
                opacity: 1,
              },
            }}
          >
            {visibleStates[state]}
          </motion.div>
        );
      })}
    </motion.div>
  );
};
